import * as React from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Control } from 'react-redux-form';
import FormItem from '../forms/FormItem';
import { renderNumericNoFullWidthTextField } from '../../common/forms/FieldCreators';
import { RecurrenceModel } from '../../common/models/Recurrence';
import nameof from '../../utils/nameof';

interface EveryNthProps {
    preInputText: string;
    postInputText: string;
    disabled: boolean;
}

export const EveryNthOccurence = (props: EveryNthProps) => (
    <FormItem>
        <Grid container direction="row" alignItems="center">
            <Grid item>
                <Typography>{props.preInputText}</Typography>
            </Grid>
            <Grid item>
                <Control.text model={`.${nameof<RecurrenceModel>("everyNthOccurrence")}`} type="number" component={renderNumericNoFullWidthTextField} disabled={props.disabled} />
            </Grid>
            <Grid item>
                <Typography>{props.postInputText}</Typography>
            </Grid>
        </Grid>
    </FormItem>
)


// WEBPACK FOOTER //
// ./src/components/recurrence/EveryNthOccurence.tsx